import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";

const CARDS = [
  { img: "/img/watch.jpg", tag: "Wearables", title: "Sample listing", pos: "left-0 top-10 w-[46%] rotate-[-7deg]", depth: 60 },
  { img: "/img/car.jpg", tag: "Vehicles", title: "Sample listing", pos: "left-[27%] top-0 w-[48%] z-10", depth: 110 },
  { img: "/img/electronics.jpg", tag: "Electronics", title: "Sample listing", pos: "right-0 top-20 w-[42%] rotate-[6deg]", depth: 40 },
];

const Card = ({ c, rx, ry, scrollY }) => {
  const x = useTransform(ry, (v) => v * (c.depth / 10));
  const y = useTransform(scrollY, [0, 800], [0, -c.depth * 0.7]);
  return (
    <motion.div style={{ x, y }} className={`absolute ${c.pos}`}>
      <div className="relative aspect-[3/4] overflow-hidden rounded-2xl border border-white/10 bg-[#12141C] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]">
        <img src={c.img} alt={c.tag} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        <span className="absolute top-3 left-3 rounded-full bg-[#FF3838] px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-wider text-[#0A0B0E]">
          Urgent
        </span>
        <div className="absolute bottom-3 left-3 right-3">
          <p className="font-mono text-[11px] uppercase tracking-widest text-zinc-300">{c.tag}</p>
          <p className="font-display text-sm font-semibold">{c.title}</p>
        </div>
      </div>
    </motion.div>
  );
};

export const HeroStack = () => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-12, 12]), { stiffness: 120, damping: 18 });
  const { scrollY } = useScroll();

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.4, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="relative h-[300px] sm:h-[460px] lg:h-[520px] [perspective:1200px]"
      data-testid="hero-listing-stack"
    >
      <div className="absolute left-1/2 top-1/2 h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#FF3838]/25 blur-[100px]" />
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative h-full w-full">
        {CARDS.map((c) => <Card key={c.img} c={c} rx={rx} ry={ry} scrollY={scrollY} />)}
      </motion.div>
    </motion.div>
  );
};
